import { render, staticRenderFns } from "./company-lowwarning.vue?vue&type=template&id=795ca718&scoped=true&"
import script from "./company-lowwarning.vue?vue&type=script&lang=ts&"
export * from "./company-lowwarning.vue?vue&type=script&lang=ts&"
import style0 from "./company-lowwarning.vue?vue&type=style&index=0&id=795ca718&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795ca718",
  null
  
)

export default component.exports